import { useEffect, useState, FC } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

//Services
import { getLocations, updateLocation } from '../../services/LocationService';

//Components
import ActivityModal from '../common/ActivityModal';
import ActivityTable from '../common/ActivityTable';
import ActivityLoading from '../common/ActivityLoading';

//Types
import { LocationInterface, ModalOptionsInterface, TableColumnInterface, TableOptionsInterface } from '../common/Types';

//Styles
import '../common/styles.scss';

//Icons
import { FaPencilAlt, FaTrash } from 'react-icons/fa';

const LocationList: FC = (props) => {
    const [modal, setModal] = useState<ModalOptionsInterface>({ open: false, header: "", body: "", buttons: [] });
    const [locations, setLocations] = useState<Array<LocationInterface>>([]);
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    useEffect(() => {
        setLoading(true);
        fetchLocations();
    }, [])

    const tableColumns: Array<TableColumnInterface> = [
        { title: "Nombre", value: "name" },
        { title: "Descripción", value: "description" },
        {
            value: "buttons",
            render: (data: LocationInterface) =>
                <div className="buttons-container-center">
                    <Button size="sm" style={{ margin: '5px' }} onClick={() => goToUpdateLocation(data)}>
                        <FaPencilAlt />
                    </Button>
                    <Button size="sm" style={{ margin: '5px' }} onClick={() => handleDisableLocation(data)}>
                        <FaTrash />
                    </Button>
                </div>
        }
    ]

    const fetchLocations = () => {
        getLocations().then((response: any) => {
            response?.sort((a1: any, a2: any) => a1.name.localeCompare(a2.name));
            setLocations(response as Array<LocationInterface>)
            setLoading(false);
        })
    }

    const goToUpdateLocation = (location: LocationInterface) => {
        history.push({ pathname: `/locations/edit/${location.id}` });
    }

    const handleDisableLocation = (location: LocationInterface) => {
        setModal({
            open: true,
            header: "Borrar",
            body: "Estas seguro de que quieres borrar esta ubicacion?",
            buttons: [
                { text: "Borrar", func: () => disableLocation(location) },
                { text: "Cancel", func: handleModalClose }
            ]
        });
    }

    const disableLocation = (location: LocationInterface) => {
        setLoading(true);
        if (location && location.id) {
            updateLocation(location.id, { deleted: true })
                .then((response: string) => {
                    handleModalClose();
                    fetchLocations();
                })
        }
    }

    const handleModalClose = () => {
        setModal({ open: false, header: "", body: "", buttons: [] });
    }

    const tableOptions: TableOptionsInterface = {
        height: 700
    }

    if (loading) return <ActivityLoading />

    return (
        <Container>
            <div style={{ marginBottom: '10px' }}>
                <h1>Ubicaciones</h1>
            </div>
            <ActivityModal {...modal} onClose={handleModalClose} />
            <div style={{ marginBottom: '15px' }}>
                <Button variant="outline-primary" onClick={() => history.push('/locations/new')} >Agregar ubicación</Button>
            </div>
            <ActivityTable data={locations ? locations : []} columns={tableColumns} options={tableOptions} />
        </Container>
    )
}

export default LocationList;
